import { useCallback, useLayoutEffect, useRef, type ReactNode } from 'react'
import { markFerramentaUtilizada } from '@services/ferramentaPersist.js'
import { FerramentaToolContext } from './ferramentaToolContext.js'

function applyNumericInputMode(root: HTMLElement) {
  root.querySelectorAll('input[type="number"]:not([inputmode])').forEach((el) => {
    el.setAttribute('inputmode', 'decimal')
  })
}

export function FerramentaToolProvider({
  toolId,
  children,
}: {
  toolId: string
  children: ReactNode
}) {
  const shellRef = useRef<HTMLDivElement>(null)
  const handleInteraction = useCallback(() => {
    markFerramentaUtilizada(toolId)
  }, [toolId])

  useLayoutEffect(() => {
    const root = shellRef.current
    if (!root) return
    applyNumericInputMode(root)
    const observer = new MutationObserver(() => applyNumericInputMode(root))
    observer.observe(root, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [toolId])

  return (
    <FerramentaToolContext.Provider value={toolId}>
      <div
        ref={shellRef}
        onClickCapture={handleInteraction}
        onChangeCapture={handleInteraction}
        onInputCapture={handleInteraction}
      >
        {children}
      </div>
    </FerramentaToolContext.Provider>
  )
}
